import clsx from 'clsx'

export const Divider = () => {
  return (
    <div className={clsx('prometheus-divider')} />
  )
}
